<template>
  <template v-if="subTitle">
    <tr v-if="column === 2">
      <td colspan="4" class="w-1/4">
        <p class="fs-8 fw-bold ms-2 m-0">{{ title }}</p>
      </td>
    </tr>
    <tr v-if="column === 4">
      <td style="background: #f8e3e5" class="w-1/4">
        <p class="fs-8 fw-bold ms-2 m-0">{{ title }}</p>
      </td>
      <td
        style="background: #f8e3e5"
        :class="[departemen ? 'w-[18.75%]' : 'w-1/4']"
      >
        <p class="fs-8 fw-bold m-0">{{ name }}</p>
      </td>
      <td
        style="background: #f8e3e5"
        v-if="departemen"
        :class="[departemen ? 'w-[18.75%]' : 'w-1/4']"
      >
        <p class="fs-8 fw-bold m-0">{{ departemen }}</p>
      </td>
      <td
        style="background: #f8e3e5"
        :class="[departemen ? 'w-[18.75%]' : 'w-1/4']"
      >
        <p class="fs-8 fw-bold m-0">{{ email }}</p>
      </td>
      <td
        style="background: #f8e3e5"
        :class="[departemen ? 'w-[18.75%]' : 'w-1/4']"
      >
        <p class="fs-8 fw-bold m-0">{{ phone }}</p>
      </td>
    </tr>
  </template>
  <tr v-for="item in data" :key="item.id">
    <td class="w-1/4">
      <p class="fs-8 ms-2 m-0">{{ item.label }}</p>
    </td>
    <template v-if="column === 2">
      <td colspan="3">
        <div
          class="d-flex flex-column"
          v-if="item.value && Array.isArray(item.value)"
        >
          <p
            class="fs-8 m-0"
            v-for="(dt, index) in item.value"
            :key="dt"
            :class="{
              'cursor-pointer': item?.file,
              'text-danger fw-bolder': item?.highlight,
            }"
            @click="item?.file ? downloadFile(dt) : ''"
          >
            <template v-if="item?.file">
              <a
                class="link-danger link-offset-2 link-underline-opacity-0 link-underline-opacity-100-hover"
              >
                {{ item?.title + `_${index + 1}.pdf` }}
              </a>
            </template>
            <template v-else>
              {{ dt }}
            </template>
          </p>
        </div>
        <p
          v-else
          class="fs-8 m-0"
          :class="{ 'fw-bolder text-danger': item?.highlight }"
          :style="{ 'white-space': item?.textArea ? 'pre-line' : 'normal' }"
        >
          {{ item.value }}
        </p>
      </td>
    </template>
    <template v-if="column === 4">
      <td>
        <div
          class="d-flex flex-column"
          v-if="item.name && Array.isArray(item.name)"
        >
          <p class="fs-8 m-0" v-for="dt in item.name" :key="dt">
            {{ dt }}
          </p>
        </div>
        <p class="fs-8 m-0" v-else>
          {{ item.name }}
        </p>
      </td>
      <td v-if="item.departemen">
        <div
          class="d-flex flex-column"
          v-if="item.departemen && Array.isArray(item.departemen)"
        >
          <p class="fs-8 m-0" v-for="dt in item.departemen" :key="dt">
            {{ dt }}
          </p>
        </div>
        <p class="fs-8 m-0" v-else>
          {{ item.departemen }}
        </p>
      </td>
      <td>
        <div
          class="d-flex flex-column"
          v-if="item.email && Array.isArray(item.email)"
        >
          <p class="fs-8 m-0" v-for="dt in item.email" :key="dt">
            {{ dt }}
          </p>
        </div>
        <p class="fs-8 m-0" v-else>
          {{ item.email }}
        </p>
      </td>
      <td>
        <div
          class="d-flex flex-column"
          v-if="item.phone && Array.isArray(item.phone)"
        >
          <p class="fs-8 m-0" v-for="dt in item.phone" :key="dt">
            {{ dt }}
          </p>
        </div>
        <p class="fs-8 m-0" v-else>
          {{ item.phone }}
        </p>
      </td>
    </template>
  </tr>
</template>
<script>
import { downloadFile } from "@/utilities/globalFunction";

export default {
  name: "TableComponent",
  props: {
    data: Array,
    column: Number,
    subTitle: Boolean,
    title: String,
    name: String,
    departemen: String,
    email: String,
    phone: String,
  },
  methods: {
    downloadFile,
  },
};
</script>

<style scoped>
tr td:first-child:not(.no-style) {
  background: #f8e3e5;
}

tr td:first-child p {
  font-weight: 600;
}

.border-item {
  padding-bottom: 0.7rem;
  border-bottom: 1px solid #ddd;
}

.border-item:not(:first-child) {
  padding-top: 0.5rem;
}

.border-item:last-child {
  padding-bottom: 0;
  border-bottom: none;
}
</style>
